/* eslint-disable import/prefer-default-export */
import { ActionTypes } from '../constants';

export function updateNotification(notifications: any) {
  return {
    type: ActionTypes.UPDATE_NOTIFICATIONS,
    payload: notifications,
  };
}

export function updateStatusType(sourceTypes: any) {
  return {
    type: 'UPDATE_SOURCE_TYPES',
    payload: sourceTypes,
  };
}

export function updateNotificationType(notificationTypes: any) {
  return {
    type: 'UPDATE_NOTIFICATION_TYPES',
    payload: notificationTypes,
  };
}

export function updateCheckSort(value: any) {
  return {
    type: ActionTypes.UPDATE_CHECK_SORT_FILTER,
    payload: value,
  };
}

export function updateViewType(value: any) {
  return {
    type: ActionTypes.UPDATE_VIEW_TYPE,
    payload: value,
  };
}